import React from 'react'

import TextField from '@material-ui/core/TextField'

import t from '../../../../translations'
import { Typography } from '@material-ui/core'
import questionIds from './questionIds'
import { describedBy, validationTextStyle, SavedNote } from './QuestionValidation'

const style = { width: '100%' }

const QuestionText = ({ question, setAnswer, answers, showLowMarkHint, isSaved, sectionHeaderId }) => {
  const pickedAnswer = answers && answers[question.questionId]
  const ids = questionIds(question.questionId)

  const pickAnswerHandler = (event) => setAnswer(question.questionId, event.target.value)

  return (
    <div className={'QuestionText'} id={ids.block}>
      <br />
      <Typography id={ids.caption} variant={'h6'} style={{ fontWeight: 700 }}>{question.caption}</Typography>
      <Typography id={ids.description} paragraph={true} variant={'body1'}>{question.description}</Typography>
      <TextField
        id={ids.input}
        onChange={pickAnswerHandler}
        value={pickedAnswer}
        placeholder={t.pollView.answerText}
        style={style}
        // Niska ocena bez uzasadnienia: podpowiedź pod każdym polem tekstowym tej grupy (znika po wpisaniu tekstu).
        error={showLowMarkHint}
        helperText={showLowMarkHint ? t.pollView.lowMarkHint : undefined}
        FormHelperTextProps={{ style: validationTextStyle }}
        // Odpowiedź zapisana przy częściowym zapisie: pole zablokowane, ekran pokazuje to, co jest w bazie.
        disabled={isSaved}
        // Etykieta pola = nagłówek sekcji + treść pytania (wcześniej tylko placeholder „Treść odpowiedzi”, ten sam
        // we wszystkich polach; sama treść pytania powtarza się przy każdym prowadzącym).
        inputProps={{
          'aria-labelledby': describedBy(sectionHeaderId, ids.caption),
          'aria-describedby': describedBy(
            question.description && ids.description,
            showLowMarkHint && ids.hint,
            isSaved && ids.saved
          ),
        }}
      />
      {isSaved ? <SavedNote id={ids.saved} /> : null}
      <br />
    </div >
  )
}

export default QuestionText